import { render, staticRenderFns } from "./TuiEditor.vue?vue&type=template&id=175e2712&scoped=true&"
import script from "./TuiEditor.vue?vue&type=script&lang=js&"
export * from "./TuiEditor.vue?vue&type=script&lang=js&"
import style0 from "./TuiEditor.vue?vue&type=style&index=0&id=175e2712&scoped=true&lang=css&"
import style1 from "./TuiEditor.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175e2712",
  null
  
)

export default component.exports